<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">账套管理</span></div>
		<div class="margin-top margin-left">
			<Button :disabled="creatorNum>=User.accountSetsNum" color="primary" @click="showForm()">新建账套</Button>&nbsp;&nbsp;
			<span>当前账套数量为{{ datas.length }}个，您可创建 <b class="red-color">{{ User.accountSetsNum <= 99 ? User.accountSetsNum : "不限数量"}}</b> 个，更多账套数请联系服务商购买~</span>
		</div>
		<div class="h-panel-body">
			<vxe-table :data="datas" :border="true" :loading="loading">
				<vxe-column :width="100" align="center">
					<template #default="{row}">
						<span class="h-tag h-tag-primary fa fa-check" v-if="row.id === currentAccountSets.id">当前</span>
					</template>
				</vxe-column>
				<vxe-column title="单位名称" field="companyName"></vxe-column>
				<vxe-column title="当前记账年月" field="currentAccountDate" :width="120" :formatter="dateFormat"></vxe-column>
				<vxe-column title="账套启用年月" field="enableDate" :width="120" :formatter="dateFormat"></vxe-column>
				<vxe-column title="会计准则" field="accountStandard" :formatter="({cellValue})=>dictMapping(cellValue,'accountingStandards')" :width="200"></vxe-column>
				<vxe-column title="凭证审核" field="voucherReviewed" :formatter="({cellValue})=>dictMapping(cellValue,'enableRadios')" :width="100"></vxe-column>
				<vxe-column title="操作" :width="140" align="center">
					<template #default="{row}">
						<div class="actions">
							<span @click="edit(row)">编辑</span>
							<span @click="remove(row)" v-if="User.role === 'ManagerBase' || User.role === 'ManagerMajor' || User.role === 'ManagerFlagship'">删除</span>
							<span @click="reset(row)" v-if="User.role === 'ManagerBase' || User.role === 'ManagerMajor' || User.role === 'ManagerFlagship'">重置</span>
						</div>
					</template>
				</vxe-column>
			</vxe-table>
		</div>
	</app-content>
</template>

<script>
import moment from 'moment';
import {mapActions, mapState} from 'vuex';
import {h} from 'vue';
import SmsVerificationCode from "../../components/SmsVerificationCode";
import {layer} from "@layui/layer-vue";
import AccountForm from "@/views/setting/account/AccountForm";
import RemoveConfirm from "@/views/setting/account/RemoveConfirm";
import ResetConfirm from "@/views/setting/account/ResetConfirm";
import {dictMapping} from "heyui.ext";


export default {
	name: 'Account',
	components: {SmsVerificationCode},
	data() {
		return {
			datas: [],
			rmData: {},
			msgCode: '',
			used: false,
			loading: false
		};
	},
	computed: {
		...mapState(["User", "currentAccountSets"]),
		creatorNum() {
			return this.datas.filter(val => val.creatorId === this.User.id).length;
		}
	},
	methods: {
		dictMapping,
		...mapActions(['init']),
		loadList() {
			this.$api.setting.accountSets.list().then(({data}) => {
				this.datas = data || [];
			})
		},
		dateFormat({cellValue}) {
			return cellValue ? moment(cellValue).format("YYYY年MM月") : '';
		},
		remove(rmData) {
			let layerId = layer.open({
				title: "删除确认",
				shadeClose: false,
				closeBtn: false,
				zIndex: 999,
				area: ['400px', '300px'],
				content: h(RemoveConfirm, {
					rmData,
					onClose: () => {
						layer.close(layerId);
					},
					onSuccess: () => {
						this.init();
						this.loadList();
						layer.close(layerId);
					}
				})
			});
		},
		reset(rmData) {
			let layerId = layer.open({
				title: "重置确认",
				shadeClose: false,
				closeBtn: false,
				zIndex: 999,
				area: ['500px', 'auto'],
				content: h(ResetConfirm, {
					rmData,
					onClose: () => {
						layer.close(layerId);
					},
					onSuccess: () => {
						this.init();
						this.loadList();
						layer.close(layerId);
					}
				})
			});
		},
		edit(row) {
			Api.setting.accountSets.checkUse(row.id).then(({data}) => {
				this.showForm(row);
			})
		},
		showForm(entity = null) {
			let layerId = layer.open({
				title: "账套信息",
				shadeClose: false,
				closeBtn: false,
				zIndex: 999,
				area: ['900px', '370px'],
				content: h(AccountForm, {
					entity,
					onClose: () => {
						layer.close(layerId);
					},
					onSuccess: () => {
						this.init();
						this.loadList();
						layer.close(layerId);
					}
				})
			});
		}
	},
	mounted() {
		this.loadList();
	}
};
</script>
